import { CompanyMaterialUsage } from '../modules/materials-usage/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { MaterialUsageView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyMaterialUsageScreen({
  view,
  onView,
  onOpenClosing,
}: {
  view: MaterialUsageView;
  onOpenClosing: (appointmentId: string) => void;
  onView: ViewSetter<MaterialUsageView>;
}) {
  const { can, timeZone, company } = useCompanyScope();
  const units = company.businessUnits ?? [];
  const consolidated = units.length > 1 && (company.activeBusinessUnitId ?? null) === null;
  return (
    <GatedCompanyScreen allowed={can('materials_usage.read')}>
      <CompanyMaterialUsage
        capabilities={{
          canReverse: !consolidated && can('materials_usage.reverse'),
          canManageSettings: !consolidated && can('materials_usage.settings.manage'),
        }}
        consolidated={consolidated}
        timeZone={timeZone}
        view={view}
        onView={onView}
        onOpenClosing={onOpenClosing}
      />
    </GatedCompanyScreen>
  );
}
